module.exports = "Finish\n\n# Song\nYouTube: f5KyvOXPqN8\n\n## Notes\n\n&nbsp;\n"


//////////////////
// WEBPACK FOOTER
// ./programs/epsHybridAssembly/sections/90_finish/finish.md
// module id = 1529
// module chunks = 2